import { varAlpha } from 'minimal-shared/utils';
import NoSsr from '@mui/material/NoSsr';
import { tabClasses } from '@mui/material/Tab';
import Tabs, { tabsClasses } from '@mui/material/Tabs';

// ----------------------------------------------------------------------

export function CustomTabs({
  children,
  slotProps,
  sx,
  ...other
}) {
  return <Tabs sx={[theme => ({
    gap: {
      sm: 0
    },
    minHeight: 38,
    flexShrink: 0,
    alignItems: 'center',
    backgroundColor: 'background.neutral',
    [`& .${tabsClasses.list}`]: {
      gap: 0,
      ...slotProps?.list
    },
    [`& .${tabsClasses.scroller}`]: {
      p: 1,
      ...slotProps?.scroller
    },
    [`& .${tabsClasses.scrollButtons}`]: {
      borderRadius: 1,
      minHeight: 'inherit',
      ...slotProps?.scrollButtons
    },
    [`& .${tabsClasses.indicator}`]: {
      py: 1,
      height: 1,
      backgroundColor: 'transparent',
      '& > span': {
        width: 1,
        height: 1,
        borderRadius: 1,
        display: 'block',
        backgroundColor: 'background.paper',
        boxShadow: theme.vars.customShadows.z1,
        border: `solid 2px ${varAlpha(theme.vars.palette.grey['600Channel'], 0.06)}`,
        ...slotProps?.indicator
      }
    },
    [`& .${tabClasses.root}`]: {
      py: 1,
      px: 2,
      zIndex: 1,
      minHeight: 'auto',
      ...slotProps?.tab,
      [`&.${tabClasses.selected}`]: {
        ...slotProps?.selected
      }
    }
  }), ...(Array.isArray(sx) ? sx : [sx])]} {...other} slotProps={{
    indicator: {
      children: <NoSsr>
              <span />
            </NoSsr>
    }
  }}>
      {children}
    </Tabs>;
}